/**
 * Get full URL for your API endpoints.
 * @param path - the path after /api
 */
export const getApiBaseUrl = (path: string = ""): string => `${import.meta.env.VITE_API_URL}${path}`;

/**
 * Resolve a potentially relative backend URL to an absolute URL.
 * Handles Rails Active Storage paths like /rails/active_storage/...
 * Absolute URLs (http/https) are returned as-is.
 */
export const resolveBackendUrl = (url: string): string => {
  if (!url || url.startsWith("http")) return url;
  const { origin } = new URL(import.meta.env.VITE_API_URL);
  return `${origin}${url}`;
};
